import axiosInstance from "../interceptor/instance";
import { formatRolesFrontEndToBAckEnd } from "../../utils/filterRoles";

const baseUrl = process.env.REACT_APP_BASE_URL_LOGS;

export const getLogs = async (params) => {
  const filteredRole = formatRolesFrontEndToBAckEnd(params.role);
  const response = await axiosInstance.get(
    baseUrl,
    { 
      params: {
        ...params, 
        role: filteredRole === "init" || filteredRole === null || filteredRole === "all users" ? undefined : filteredRole
      } 
    }
  );
  return response.data;
};

export const storeMapLogsInBE = async (data) => {
  const response = await axiosInstance.post(
    `${baseUrl}/map`,
    { logs: data }
  );
  return response.data;
};
